module.exports = __webpack_public_path__ + "static/media/hh_logo_yellow.ee05b7b7.svg";